import React, { Fragment } from "react"
import VisitorAccess from "./VisitorAccess"
import WebhookSection from "./WebhookSection"
import SiteDetailsSection from "./SiteDetailsSection"
import { NotificationDeploysSection } from "./NotificationDeploysSection"
import { SiteSettingsSection, SiteSettingsSectionLabel } from "../constants"
import { isProduction } from "../../../env/constants"
import { EnvironmentVariablesCard } from "@modules/site/envVars/components/EnvironmentVariablesCard"
import { DangerZone } from "./DangerZone"

export default function GeneralSettingsSection({
  sections,
  organizationId,
  siteId,
  siteName,
  productionBranch,
  sitePreviewDirectory,
  sitePreviewProtection,
  sitePreviewPassword,
  siteDescription,
  buildsEnabled,
  repository,
  sitePrefix,
  permissions,
}) {
  return sections.map(({ name }) => {
    let cardElement
    switch (name) {
      case SiteSettingsSection.SiteDetails:
        cardElement = (
          <SiteDetailsSection
            siteName={siteName}
            sitePrefix={sitePrefix}
            repositoryUrl={repository?.url}
            sitePreviewDirectory={sitePreviewDirectory}
            siteId={siteId}
            productionBranch={productionBranch}
            siteDescription={siteDescription}
          />
        )
        break

      case SiteSettingsSection.EnvVars:
        cardElement = (
          <EnvironmentVariablesCard
            siteId={siteId}
            organizationId={organizationId}
            siteBuildsEnabled={buildsEnabled}
            cardId={SiteSettingsSection.EnvVars}
            title={SiteSettingsSectionLabel[SiteSettingsSection.EnvVars]}
            uiSource="Site settings"
          />
        )
        break

      case SiteSettingsSection.Webhook:
        cardElement = (
          <Fragment>
            <WebhookSection
              siteId={siteId}
              organizationId={organizationId}
              buildsEnabled={buildsEnabled}
            />
          </Fragment>
        )
        break

      case SiteSettingsSection.VisitorAccess:
        cardElement = (
          <VisitorAccess
            siteId={siteId}
            organizationId={organizationId}
            sitePreviewProtection={sitePreviewProtection}
            sitePreviewPassword={sitePreviewPassword}
          />
        )
        break

      case SiteSettingsSection.NotificationDeploys:
        cardElement = <NotificationDeploysSection siteId={siteId} />
        break

      case SiteSettingsSection.Danger:
        cardElement = (
          <DangerZone
            siteId={siteId}
            siteName={siteName}
            permissions={permissions}
            organizationId={organizationId}
          />
        )
        break

      default:
        if (!isProduction) {
          console.error(`Unexpected section found: ${name}`)
        }
        cardElement = null
    }

    return <React.Fragment key={name}>{cardElement}</React.Fragment>
  })
}
